module.exports = __webpack_public_path__ + "img/primer-respondiente.63a09e66.jpg";